import type { RouteRecordRaw } from 'vue-router'

import { MCP_PRODUCT_CAROUSEL } from './route-names'

export default (): RouteRecordRaw[] => {
  return [
    {
      component: () => import('~/scopes/mcp/pages/ProductCarousel.vue'),
      name: MCP_PRODUCT_CAROUSEL,
      path: 'mcp/product-carousel',
      meta: {
        layout: 'mcp-default',
        owners: ['bot-group-ai-shopping-assistant-front'],
      },
    },
  ]
}
